import { render, staticRenderFns } from "./SelectStickerMenuFacebook.vue?vue&type=template&id=55b7238c&"
import script from "./SelectStickerMenuFacebook.vue?vue&type=script&lang=js&"
export * from "./SelectStickerMenuFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports